import {
    type Announcement,
    type Certificate,
    type CertificateInstance,
    type CertificateType,
    type Company,
    type Logging,
    setAnnouncements,
    setCertificateInstances,
    setCertificates,
    setCertificateTypes,
    setCompanies,
    setEnrichedCertificates,
    setIsCertificateInstancesRequested,
    setIsCompaniesRequested,
    setLoggings,
    setUsers,
    type User,
} from '../Store/DataSlice'
import {subscribe} from '../Store/State'
import {type RootState, store} from '../Store/Store'
import {getAuthorizationHeader} from './Authentication'
import {createSelector} from 'reselect'
import {inBrowserCalculateEnrichedCertificates} from './Webworker'

export function orchestrateData() {
    subscribe(
        (state: RootState) => state.data.isCompaniesRequested,
        (isCompaniesRequested, wasCompaniesRequested) => {
            if (isCompaniesRequested && !wasCompaniesRequested) {

                getItems<Company>(
                    // 'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/company-list'
                    'https://t7dk3mltc24sldye2lijsh5rhq0fqtst.lambda-url.eu-west-1.on.aws/'
                )
                    .then((items) => {
                        store.dispatch(setCompanies(items));
                    })
                    .catch((err) => {
                        console.warn(`fetch company-list failed: `, err)
                    })
            }
        }
    )
    subscribe(
        (state: RootState) => state.data.isCertificateInstancesRequested,
        (isCertificateInstancesRequested, wasCertificateInstancesRequested) => {
            if (
                isCertificateInstancesRequested &&
                !wasCertificateInstancesRequested
            ) {
                getItems<CertificateInstance>(
                    'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/certificate-instance-list'
                )
                    .then((items) => {
                        store.dispatch(setCertificateInstances(items))
                    })
                    .catch((err) => {
                        console.warn(`fetch certificate-instance-list failed: `, err)
                    })
            }
        }
    )
    subscribe(
        (state: RootState) => state.data.isUsersRequested,
        (isUsersRequested, wasUsersRequested) => {
            if (isUsersRequested && !wasUsersRequested) {
                getItems<User>(
                    'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/user-list'
                )
                    .then((items) => {
                        store.dispatch(setUsers(items))
                    })
                    .catch((err) => {
                        console.warn(`fetch user-list failed: `, err)
                    })
            }
        }
    )

    subscribe(
        (state: RootState) => state.data.isCertificatesRequested,
        (isCertificatesRequested, wasCertificatesRequested) => {
            if (isCertificatesRequested && !wasCertificatesRequested) {

                getItems<Certificate>(
                    // 'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/certificate-list'
                    'https://e5wt23547yehlfhrqabofhezpa0yfwtm.lambda-url.eu-west-1.on.aws/'
                )
                    .then((items) => {
                        store.dispatch(setCertificates(items));
                    })
                    .catch((err) => {
                        console.warn(`fetch certificate-list failed: `, err)
                    })
                // if certificates are requested, make sure certificate instances & companies are fetched at least once
                if (
                    !store.getState().data.isCertificateInstancesRequested &&
                    store.getState().data.certificateInstances.length === 0
                )
                    store.dispatch(setIsCertificateInstancesRequested(true))
                if (
                    !store.getState().data.isCompaniesRequested &&
                    store.getState().data.companies.length === 0
                )
                    store.dispatch(setIsCompaniesRequested(true))
            }
        }
    )
    subscribe(
        (state: RootState) => state.data.isCertificateTypesRequested,
        (isCertificateTypesRequested, wasCertificateTypesRequested) => {
            if (isCertificateTypesRequested && !wasCertificateTypesRequested) {
                getItems<CertificateType>(
                    'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/certificate-type-list'
                )
                    .then((items) => {

                        items.forEach(item => {

                            if (!item.requiredCertificateNumbers) {
                                item.requiredCertificateNumbers = [];
                            }
                            if (!item.naceLimitation) {
                                item.naceLimitation = [];
                            }

                        });

                        return items;
                    })
                    .then((items) => {
                        store.dispatch(setCertificateTypes(items))
                    })
                    .catch((err) => {
                        console.warn(`fetch certificate-type-list failed: `, err)
                    })
            }
        }
    )
    subscribe(
        (state: RootState) => state.data.isLoggingsRequested,
        (isLoggingsRequested, wasLoggingsRequested) => {

            if (isLoggingsRequested) {

                const fromDateMillis = new Date().getTime() - 864000000; // 10 days in millis

                let itemsLastTenDays: Logging[];

                getItems<Logging>(
                    'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/logging-list', undefined, fromDateMillis, true
                )
                    .then((items) => {
                        itemsLastTenDays = items;
                        store.dispatch(setLoggings(items))
                    })
                    .then(() => {
                        getItems<Logging>(
                            'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/logging-list', undefined, fromDateMillis, false
                        ).then((items) => {
                            itemsLastTenDays = [...itemsLastTenDays, ...items];
                            store.dispatch(setLoggings(itemsLastTenDays));
                        })
                            .catch((err) => {
                                console.warn(`fetch logging-list failed: `, err)
                            })
                    })
                    .catch((err) => {
                        console.warn(`fetch logging-list failed: `, err)
                    })
            }
        }
    )
    subscribe(
        (state: RootState) => state.data.isAnnouncementsRequested,
        (isAnnouncementsRequested, wasAnnouncementsRequested) => {
            if (isAnnouncementsRequested && !wasAnnouncementsRequested) {
                getItems<Announcement>(
                    'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/announcement-list'
                )
                    .then((items) => {
                        store.dispatch(setAnnouncements(items))
                    })
                    .catch((err) => {
                        console.warn(`fetch announcement-list failed: `, err)
                    })
            }
        }
    )

    subscribe(
        createSelector(
            (state: RootState) => state.data.certificates,
            (state: RootState) => state.data.companies,
            (state: RootState) => state.data.certificateInstances,
            (certificates, companies, certificateInstances) => ({
                certificates,
                companies,
                certificateInstances,
            })
        ),
        ({certificates, companies, certificateInstances}) => {

            store.dispatch(
                setEnrichedCertificates(
                    inBrowserCalculateEnrichedCertificates(
                        certificates, companies, certificateInstances
                    )
                )
            );

            /* runWebWorkerScript(
                'enrich-certs.mjs',
                {certificates, companies, certificateInstances},
                (ev: MessageEvent<any>) => {
                    store.dispatch(
                        setEnrichedCertificates(ev.data as EnrichedCertificate[])
                    )
                }
            ); */
        }
    )
}

async function getItems<T>(url: string, lastEvaluatedKey?: unknown, fromDateMillis?: number, isAfter?: boolean) {
    return await new Promise<T[]>((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthorizationHeader(),
            },
            body: JSON.stringify({
                lastEvaluatedKey,
                fromDateMillis,
                isAfter
            }),
        })
            .then(async (response) => await response.json())
            .then(
                (response: {
                    success: true
                    items: T[]
                    lastEvaluatedKey: unknown
                }) => {
                    if (response.lastEvaluatedKey !== undefined) {
                        getItems<T>(url, response.lastEvaluatedKey, fromDateMillis, isAfter)
                            .then((items: T[]) => {
                                resolve([...response.items, ...items])
                            })
                            .catch((err) => {
                                reject(err)
                            })
                    } else {
                        resolve(response.items)
                    }
                }
            )
            .catch((err) => {
                reject(err)
            })
    })
}
